import type { HeadingProps } from "@/types";

/**
 * Heading Component
 * Renders h1-h6 elements with Tailwind styling
 * Supports custom colors from the Tailwind theme
 */
export const Heading = ({
  level,
  children,
  className = "",
  color = "black",
}: HeadingProps) => {
  const Tag = level;

  // Size classes for each heading level with responsive sizing
  const sizeClasses = {
    h1: "text-3xl md:text-5xl font-archivo-black leading-none",
    h2: "text-2xl md:text-3xl lg:text-4xl font-archivo-black leading-snug uppercase",
    h3: "text-xl md:text-2xl font-archivo-black leading-snug",
    h4: "text-lg md:text-xl lg:text-2xl font-archivo-black leading-snug",
    h5: "text-base md:text-lg lg:text-xl font-archivo-black leading-normal",
    h6: "text-sm md:text-base lg:text-lg font-archivo-black leading-normal",
  };

  // Color classes using custom Tailwind colors
  const colorClasses = {
    primary: "text-primary",
    secondary: "text-secondary",
    black: "text-theme-text",
    white: "text-theme-text",
    gray: "text-theme-text-secondary",
  };

  return (
    <Tag
      className={`${sizeClasses[level]} ${colorClasses[color]} whitespace-pre-line ${className}`}
    >
      {children}
    </Tag>
  );
};

export default Heading;
